// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type TradePartnerContactsRolesPanelMetadataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type TradePartnerContactsRolesPanelMetadataQuery = { __typename?: 'Query', tradePartnerMarketRoles: Array<{ __typename?: 'TradePartnerMarketRoleDetail', code: Types.TradePartnerMarketRole, name: string, sortOrder: number }> };


export const TradePartnerContactsRolesPanelMetadataDocument = gql`
    query TradePartnerContactsRolesPanelMetadata {
  tradePartnerMarketRoles {
    code
    name
    sortOrder
  }
}
    `;

/**
 * __useTradePartnerContactsRolesPanelMetadataQuery__
 *
 * To run a query within a React component, call `useTradePartnerContactsRolesPanelMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradePartnerContactsRolesPanelMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradePartnerContactsRolesPanelMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useTradePartnerContactsRolesPanelMetadataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TradePartnerContactsRolesPanelMetadataQuery, TradePartnerContactsRolesPanelMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TradePartnerContactsRolesPanelMetadataQuery, TradePartnerContactsRolesPanelMetadataQueryVariables>(TradePartnerContactsRolesPanelMetadataDocument, options);
      }
export function useTradePartnerContactsRolesPanelMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TradePartnerContactsRolesPanelMetadataQuery, TradePartnerContactsRolesPanelMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TradePartnerContactsRolesPanelMetadataQuery, TradePartnerContactsRolesPanelMetadataQueryVariables>(TradePartnerContactsRolesPanelMetadataDocument, options);
        }
// @ts-ignore
export function useTradePartnerContactsRolesPanelMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TradePartnerContactsRolesPanelMetadataQuery, TradePartnerContactsRolesPanelMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TradePartnerContactsRolesPanelMetadataQuery, TradePartnerContactsRolesPanelMetadataQueryVariables>;
export function useTradePartnerContactsRolesPanelMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TradePartnerContactsRolesPanelMetadataQuery, TradePartnerContactsRolesPanelMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TradePartnerContactsRolesPanelMetadataQuery | undefined, TradePartnerContactsRolesPanelMetadataQueryVariables>;
export function useTradePartnerContactsRolesPanelMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TradePartnerContactsRolesPanelMetadataQuery, TradePartnerContactsRolesPanelMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TradePartnerContactsRolesPanelMetadataQuery, TradePartnerContactsRolesPanelMetadataQueryVariables>(TradePartnerContactsRolesPanelMetadataDocument, options);
        }
export type TradePartnerContactsRolesPanelMetadataQueryHookResult = ReturnType<typeof useTradePartnerContactsRolesPanelMetadataQuery>;
export type TradePartnerContactsRolesPanelMetadataLazyQueryHookResult = ReturnType<typeof useTradePartnerContactsRolesPanelMetadataLazyQuery>;
export type TradePartnerContactsRolesPanelMetadataSuspenseQueryHookResult = ReturnType<typeof useTradePartnerContactsRolesPanelMetadataSuspenseQuery>;
export type TradePartnerContactsRolesPanelMetadataQueryResult = Apollo.QueryResult<TradePartnerContactsRolesPanelMetadataQuery, TradePartnerContactsRolesPanelMetadataQueryVariables>;